import { TZDate } from '@date-fns/tz';
import { DEFAULT_DATE_TIME_FORMAT, ZURICH_TZ } from '@shared/constants';
import { stringNullComparator } from '@shared/utils/comparator.util';
import { ColDef } from 'ag-grid-community';
import { format } from 'date-fns';

export const TREATY_PAGE_SIZE = 25;

export const treatiesDefaultColDef: ColDef = {
  flex: 1,
};

export const treatiesColDefs: ColDef[] = [
  {
    field: 'createdDatetime',
    headerName: 'Created Date',
    valueFormatter: params => {
      const tzDate = TZDate.tz(ZURICH_TZ, params.value);
      return params.value ? format(tzDate, DEFAULT_DATE_TIME_FORMAT) : '';
    },
    maxWidth: 200,
  },
  {
    field: 'treatyId',
    headerName: 'Treaty Id',
    maxWidth: 150,
  },
  {
    field: 'treatyPortfolioName',
    headerName: 'Portfolio name (optional)',
    comparator: stringNullComparator,
  },
  {
    field: 'type',
    headerName: 'Type',
  },
  {
    field: 'treatyState',
    headerName: 'State',
  },
  {
    field: 'createdByName',
    headerName: 'Created By',
  },
];

export const casualtyColDefs: ColDef[] = [
  { field: 'inputCompanyName', headerName: 'Input Insured Name' },
  { field: 'inputLimit', headerName: 'Input Limit' },
  { field: 'inputPremium', headerName: 'Input Premium' },
  { field: 'inputCountry', headerName: 'Input Country' },
  { field: 'inputOccupancy', headerName: 'Input Occupancy' },
  { field: 'matchingCompanyName', headerName: 'Matching Company Name' },
  { field: 'companyIndustryWorstScore', headerName: 'Company Sector Worst Score' },
  { field: 'companyWorstIndustry', headerName: 'Company Worst Sector' },
  { field: 'companyComment', headerName: 'Company Comment' },
  { field: 'companyControversy', headerName: 'Company Controversy' },
  { field: 'matchingCountryName', headerName: 'Matching Country Name' },
  { field: 'matchingSectorName', headerName: 'Matching Sector Name' },
  { field: 'countrySectorRiskScore', headerName: 'Country Sector Risk Score' },
];

export const propertyColDefs = [
  { field: 'inputCompanyName', headerName: 'Input Insured Name' },
  { field: 'inputLimit', headerName: 'Input Limit' },
  { field: 'inputPremium', headerName: 'Input Premium' },
  { field: 'inputCountry', headerName: 'Input Country' },
  { field: 'inputOccupancy', headerName: 'Input Occupancy' },
  { field: 'inputLatitude', headerName: 'Input Latitude' },
  { field: 'inputLongitude', headerName: 'Input Longitude' },
  { field: 'matchingCompanyName', headerName: 'Matching Company Name' },
  { field: 'companyIndustryWorstScore', headerName: 'Company Sector Worst Score' },
  { field: 'companyWorstIndustry', headerName: 'Company Worst Sector' },
  { field: 'companyComment', headerName: 'Company Comment' },
  { field: 'companyControversy', headerName: 'Company Controversy' },
  { field: 'matchingCountryName', headerName: 'Matching Country Name' },
  { field: 'matchingSectorName', headerName: 'Matching Sector Name' },
  { field: 'countrySectorRiskScore', headerName: 'Country Sector Risk Score' },
];
